import { cloneDeep } from 'lodash-es';
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service';

// requiring html templates so that hot reloading works
const template = require('./datePicker.html');

const NS = 'DatePicker'; // jshint ignore:line

export default function DatePicker() { // as datePicker
  "ngInject";

  return {
    bindToController: true,
    controller: Controller,
    controllerAs: 'vm',
    template,
    restrict: 'E',
    scope: {
      pickerDate: '=',
      hideDays: '='
    },
    link: function (scope) {
      scope.buildDayLinks();
    }
  };

  function Controller($scope, $filter, $mdDialog, $rootScope) {
    "ngInject";

    const vm = this;

    //-- define public properties
    vm.showFullPicker = false;
    //-- define public methods
    vm.nextDay = nextDay;
    vm.previousDay = previousDay;
    vm.changeDay = changeDay;
    vm.showPicker = showPicker;
    vm.closePicker = closePicker;
    vm.savePickerDate = savePickerDate;
    vm.save = save;

    $scope.buildDayLinks = buildDayLinks;

    function nextDay() {
      vm.pickerDate = new Date(vm.pickerDate.getFullYear(), vm.pickerDate.getMonth(), vm.pickerDate.getDate() + 1);
    }

    function previousDay() {
      vm.pickerDate = new Date(vm.pickerDate.getFullYear(), vm.pickerDate.getMonth(), vm.pickerDate.getDate() - 1);
    }

    function save(value) {
      vm.pickerDate = value;
      closePicker();
    }

    function showPicker(evt) {
      $mdDialog.show({
        templateUrl: 'app/common/datePickerDialog/datePickerDialog.html',
        locals: {
          date: cloneDeep(vm.pickerDate),
          onCancel: closePicker,
          onSave: savePickerDate,
          displayMode: 'date'
        },
        controller: 'DatePickerDialogCtrl',
        bindToController: true,
        controllerAs: 'vm',
        targetEvent: evt,
        clickOutsideToClose: true
      });
    }

    function savePickerDate(newDate) {
      newDate.setHours(0);
      newDate.setMinutes(0);
      newDate.setSeconds(0);
      newDate.setMilliseconds(0);
      vm.pickerDate = newDate;
      closePicker();
    }

    function closePicker() {
      $mdDialog.cancel();
    }

    function changeDay(dateStr) {
      vm.pickerDate = DateUtilsService.dateStrToDate(dateStr, '-');
    }

    function buildDayLinks() {
      if (vm.pickerDate) {
        // var day = new Date(vm.pickerDate.getFullYear(), vm.pickerDate.getMonth(), vm.pickerDate.getDate());
        // instead of pickerDate using current date
        const timeZoneId = AdminService.getVenueTimezoneId();
        const day = DateUtilsService.getClearDate(null, timeZoneId);
        day.setDate(day.getDate() - 1);
        const days = [];
        for (let i = 0; i < 7; i++) {
          let label = $filter('date')(day, 'EEE');
          let dayClass = '';
          if (i === 1) {
            dayClass = 'today';
            label = "Today";
          }
          days.push({
            dateStr: DateUtilsService.dateToIdStr(day),
            label: label,
            dayClass: dayClass
          });

          day.setDate(day.getDate() + 1);
        }
        vm.days = days;
      }
    }
  }
}
